import React from 'react';
import axios from 'axios';

import ProjectThumbnail from './ProjectThumbnail';
import  { withRouter } from 'react-router-dom'

class WorkList extends React.Component {
  workListStorageKey = 'pyovspyo_work_items';

  apiEndpoint = 'https://lrfiosxbs6.execute-api.ap-northeast-2.amazonaws.com';
  imageBaseUrl = 'https://d1aummmer0n4kg.cloudfront.net/media/';
  state = {
    list: [],
    isLoading: true
  }

  resolveImageUrl = (image) => {
    if (!image) {
      return image;
    }

    if (
      image.startsWith('http://') ||
      image.startsWith('https://') ||
      image.startsWith('//')
    ) {
      return image;
    }

    return `${this.imageBaseUrl}${image.replace(/^\/+/, '')}`;
  }

  componentDidMount() {
    axios.get(`${this.apiEndpoint}/default/works`, {
      params: {
        type: 'all'
      }
    }).then((response) => {
      const items = response.data && Array.isArray(response.data.items) ? response.data.items : [];

      sessionStorage.setItem(this.workListStorageKey, JSON.stringify(items));

      var content = items.map((item) => {
        return (
          <ProjectThumbnail 
            title={item.title}
            image={this.resolveImageUrl(item.thumbnail || item.image)}
            key={item.id}
            id={item.id}
            handleItemClick={() => this.handleItemClick(item)}
          />
        );
      });
      this.setState({
        list: content,
        isLoading: false
      })
    }).catch((error) => {
      console.error(error);
      this.setState({ isLoading: false });
    });
  }
  
  handleItemClick = (workItem) => {
    this.props.history.push(`/work/${workItem.id}`, {
      workItem
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="public-content-loading">
          <div className="public-content-spinner" />
        </div>
      );
    }

    return (
      <>
        <div className="row match-height">
          {this.state.list}
        </div>
      </>
    );
  }
}

export default withRouter(WorkList);
